import { Component } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {UserService} from "app/user/user.service";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {TranslateService} from "../../translate";
import {UserProvider, UserRole } from "app/models/acl.model";
import {ModalService} from "../../views/modal/base_modal.component";
import {ProviderFormComponent} from "./provider_form.component";
import {RoleFormComponent} from "./role_form.component";

import dictionary from "dict/static.json";
import {SupportService} from "app/support/support/support.service";
import { FilterParams } from "../../models/filter_form.model";
import { mergeFilterParams } from "../../lib/lib";

@Component({
  selector: 'acl',
  templateUrl: './acl.component.html'
})
export class AclComponent extends BaseComponent {
	providers: UserProvider[] = [];
	isProviderLoad: boolean = false;
	
	roles: UserRole[] = [];
	isRoleLoad: boolean = false;
	
	constructor(
		public eventsService: EventsService,
		public service: UserService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService,
		public modalService: ModalService,
		public supportService: SupportService,
	) {
		super(eventsService, service, activatedRoute, filter, translate);
	}
	
	async getData() {
		this.isProviderLoad = true;
		this.providers = await this.service.getProviderList().toPromise();
		this.isProviderLoad = false;
		
		this.isRoleLoad = true;
		this.roles     = await this.service.getRoleList().toPromise();
		this.isRoleLoad = false;
	}
	
	
	async addProvider() {
		const modal = this.modalService.open(ProviderFormComponent, {
			title: this.__a('other.add'),
		});
		const r = await modal.result;
		
		if (r !== 'cancel') {
			const provider = await this.service.addProvider(r).toPromise();
			this.providers.push(provider);
		}
	}
	
	
	async editProvider(provider: UserProvider) {
		const modal = this.modalService.open(ProviderFormComponent, {
			title: this.__a('other.edit'),
		});
		modal.componentInstance.form.setData(provider);
		modal.componentInstance.filter.reset();
		modal.componentInstance.filter.filterParams = this.filter.getCopyFilterParams(
			mergeFilterParams(
				new FilterParams(),
				provider.filter,
			)
		);
		
		const r = await modal.result;
		
		if (r !== 'cancel') {
			const updatedProvider = await this.service.editProvider(r).toPromise();
			
			Object.keys(updatedProvider)
				.forEach(key => provider[key] = updatedProvider[key]);
		}
	}
	
	
	async deleteProvider(provider: UserProvider) {
		await this.service.deleteProvider(provider).toPromise();
		this.providers = this.providers.filter(p => p._id !== provider._id);
	}
	
	
	async addRole() {
		const modal = this.modalService.open(RoleFormComponent, {
			title            : this.__a('other.add'),
			providerNameList : this.providers.map(p => p.name),
			roleNameList     : dictionary.roleList,
		});
		const r = await modal.result;
		
		if (r !== 'cancel') {
			const { userId } = await this.supportService.searchByEmail(r.email).toPromise();
			r.userId = userId;
			const role = await this.service.addRole(r).toPromise();
			this.roles.push(role);
		}
	}
	
	
	async editRole(role: UserRole) {
		const modal = this.modalService.open(RoleFormComponent, {
			title            : this.__a('other.edit'),
			providerNameList : this.providers.map(p => p.name),
			roleNameList     : dictionary.roleList,
		});
		modal.componentInstance.setRole(role);
		
		const r = await modal.result;
		
		if (r !== 'cancel') {
			const updatedRole = await this.service.editRole(r).toPromise();
			
			Object.keys(updatedRole)
				.forEach(key => role[key] = updatedRole[key]);
		}
	}
	
	
	async deleteRole(role: UserRole) {
		await this.service.deleteRole(role).toPromise();
		this.roles = this.roles.filter(r => r._id !== role._id);
	}
}
